export const companyData = {
  name: "GLAZZARTO TECHNOLOGIES PRIVATE LIMITED",
  cin: "U47912UP2025PTC220541",
  roc: "RoC-Kanpur",
  regNo: "220541",
  status: "Active",
  incorporated: "04-04-2025",
  lastUpdated: "18-01-2026",
  category: "Company limited by shares",
  subCategory: "Non-government company",
  classOfCompany: "Private",
  authorizedCapital: "₹1,00,000",
  paidUpCapital: "₹10,000",
  listed: "Unlisted",
  suspended: "No",
  email: "glazzarto@gmail.com",
  address: "CO SHEEL YADAV PATEL NAGAR SHIV MANDIR Nilmatha Lucknow Uttar Pradesh India 226002",
  source: "IndiaFilings / Ministry of Corporate Affairs (MCA) – Public Data",
  directors: [
    { din: "11039563", name: "ANJALI SINGH", since: "04-04-2025" },
    { din: "11039564", name: "SURYA PRATAP SINGH CHAUHAN", since: "04-04-2025" },
    { din: "11039565", name: "MAYANK PRATAP SINGH CHAUHAN", since: "04-04-2025" },
  ],
};

export const cases = [
  {
    id: 1,
    name: "Anonymous Employee #1",
    role: "Frontend Developer",
    duration: "2 months",
    amount: "₹2500",
    amountNum: 2500,
    date: "1–feb 2026",
    avatar: "FD",
    color: "#e63946",
    summary: "2 mahine kaam karaya, payments avoid kiye, phir legal threats diye jab payment maangi.",
    details: [
      "Maine Glazzarto ke saath October 2025 mein kaam shuru kiya tha. Mujhe Frontend Developer ke role pe hire kiya gaya tha — terms verbally agree ki gayi thi, koi written contract provide nahi kiya gaya.",
      "2 mahine kaam karne ke baad jab maine payment maangi toh pehle excuses aaye — 'account issue hai', 'client ne payment nahi ki', 'thoda wait karo'. Har baar ek naya reason hota tha.",
      "Jab maine legal action ki baat ki toh khud hi legal language use karke mujhe intimidate karne ki koshish ki gayi — bola gaya ki 'jo bhi bahar bolega uske against action lenge'.",
      "Total ₹18,000 outstanding hai jo aaj tak nahi mila. Kaam deliver kiya gaya, confirm bhi hua, lekin payment zero."
    ],
    redFlags: [
      "No written contract — sirf verbal agreement",
      "Payment delays with rotating fake excuses",
      "Legal intimidation when payment was demanded",
      "Communication gradually reduced after work delivered",
      "Invoice accepted but payment never processed"
    ],
    evidence: [
      "Invoice dated November 2025",
      "WhatsApp conversation screenshots",
      "Work delivery confirmation via email",
      "Screen recording of completed project"
    ],
    timeline: [
      { date: "Oct 2025", event: "Hired verbally, kaam shuru" },
      { date: "Nov 2025", event: "Project deliver kiya" },
      { date: "Nov 2025", event: "Invoice bheja — 'wait karo' bola" },
      { date: "Dec 2025", event: "Payment refuse, legal threats" },
      { date: "Jan 2026", event: "Aaj tak payment nahi" },
    ]
  },
  {
    id: 2,
    name: "Anonymous Employee #2",
    role: "UI/UX Designer",
    duration: "6 weeks",
    amount: "₹12,500",
    amountNum: 12500,
    date: "Nov–Dec 2025",
    avatar: "UX",
    color: "#f4a261",
    summary: "Multiple false statements diye, invoice dispute kiya bina reason ke, aur payment band kar di.",
    details: [
      "November 2025 mein mujhe UI/UX Designer ke liye approach kiya gaya. Founders ne personally guarantee di thi ki payment on-time hogi — timeline 15 din ka tha.",
      "6 weeks ke intense design kaam ke baad jab invoice send kiya toh pehle invoice ko 'incomplete work' bol ke reject kiya. Koi specific feedback nahi diya gaya ki kya issue hai.",
      "Phir bola gaya 'hum toh sirf 50% denge kyunki design revisions ki wajah se'. Woh 50% bhi kabhi nahi aaya.",
      "Multiple false statements diye gaye conversation mein — kabhi bola 'investor funding nahi aayi isliye', kabhi bola 'client ne final approval nahi di'. Dono claims baad mein contradict karte mile.",
      "Total ₹12,500 mera pending hai. Design files deliver ho chuki hain, company use bhi kar rahi hai."
    ],
    redFlags: [
      "Invoice disputed without clear reason",
      "Promised 50% compromise payment — never delivered",
      "Contradictory false statements across conversations",
      "Delivered designs used by company without payment",
      "Personal payment guarantee later denied"
    ],
    evidence: [
      "Design delivery files (Figma link shared)",
      "Email thread with false financial claims",
      "WhatsApp screenshots of payment promise",
      "Invoice acceptance confirmation"
    ],
    timeline: [
      { date: "Nov ", event: "Hired with verbal payment guarantee" },
      { date: "Dec 2025", event: "All design files delivered" },
      { date: "Dec 2025", event: "Invoice rejected — 'incomplete' bola" },
      { date: "Dec 2025", event: "50% offer phir woh bhi cancel" },
      { date: "Jan 2026", event: "Company designs use kar rahi, payment zero" },
    ]
  },
  {
    id: 3,
    name: "Anonymous Employee #3",
    role: "Backend Developer",
    duration: "3 months",
    amount: "₹45,000",
    amountNum: 45000,
    date: "Sep–Nov 2025",
    avatar: "BD",
    color: "#2a9d8f",
    summary: "3 mahine kaam karaya, phir company ne contact band kar diya aur jhootha bola ki company band ho rahi hai.",
    details: [
      "September se November 2025 tak maine Glazzarto ke liye complete backend development ki — APIs, database design, aur deployment sab meri responsibility thi.",
      "November ke end mein jab payment ki deadline aayi toh calls attend karna band ho gaya. WhatsApp pe messages read toh hote the lekin reply band.",
      "Emails ka jawab aana completely band ho gaya. Ek mutual contact ke zariye jab finally reach kiya toh bola gaya 'company khatam ho rahi hai, koi payment possible nahi'.",
      "Lekin MCA portal pe Glazzarto Technologies abhi bhi 'Active' status mein hai — company band hone ka claim bilkul jhootha tha.",
      "₹45,000 outstanding hai. Yeh sabse bada case hai — 3 mahine ki mehnat, zero payment."
    ],
    redFlags: [
      "Ghost strategy — calls, messages, emails sab band",
      "False claim of company closure to avoid payment",
      "MCA portal pe company abhi bhi 'Active' — lie caught",
      "3 months of full-time unpaid work",
      "No exit process, no communication"
    ],
    evidence: [
      "GitHub commit history (3 months of commits)",
      "All project files delivered and deployed",
      "Last unanswered email — December 2025",
      "MCA portal screenshot showing 'Active' status"
    ],
    timeline: [
      { date: "Sep 2025", event: "Project shuru, terms agreed" },
      { date: "Oct 2025", event: "Backend core deliver kiya" },
      { date: "Nov 2025", event: "Final delivery, payment due" },
      { date: "Nov 2025", event: "Calls, messages ignore hone lage" },
      { date: "Dec 2025", event: "'Company band ho rahi' — jhootha claim" },
      { date: "Jan 2026", event: "MCA pe company 'Active', payment nahi" },
    ]
  },
];

export const commonPatterns = [
  {
    icon: "💼",
    step: "01",
    title: "Hire karo, kaam lo",
    desc: "Pehle attractive role offer ki jaati hai — developer, designer, marketer. Verbal promises, no written contract. Kaam shuru ho jaata hai."
  },
  {
    icon: "⏳",
    step: "02",
    title: "Delivery ke baad delay",
    desc: "Jab kaam deliver hota hai toh payment mein 'thoda wait karo' shuru hota hai. Rotating excuses: bank issue, client delay, fund awaited."
  },
  {
    icon: "📋",
    step: "03",
    title: "False Statements",
    desc: "Invoice dispute kiya jaata hai bina reason ke. 'Kaam sahi nahi tha', 'revision chahiye', 'incomplete hai' — jabki kaam accept ho chuka hota hai."
  },
  {
    icon: "⚖️",
    step: "04",
    title: "Legal Intimidation",
    desc: "Jab aap paisa maangein toh legal language se daraya jaata hai. 'NDA breach', 'defamation case' — taaki aap chup ho jaao aur payment chhod do."
  },
  {
    icon: "👻",
    step: "05",
    title: "Ghost Ban Jaate Hain",
    desc: "Gradually calls reduce hote hain, phir messages read hote hain lekin reply nahi. Ek din completely unreachable. Company 'Active' rehti hai MCA pe."
  },
  {
    icon: "🔄",
    step: "06",
    title: "Pattern Repeat",
    desc: "Yeh pattern multiple employees ke saath repeat hua hai independently. Same excuses, same timeline, same outcome — zero payment."
  },
];
